import { Component } from 'react';
import { connect } from 'react-redux';
import { Tooltip } from 'react-tooltip';

import DirectionArraw from 'components/atoms/DirectionArraw';
import Icon from 'components/atoms/Icon';
import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { OUTLINE_INTERVALS } from 'data/static';
import { bindActionCreators } from 'redux';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import {
    DataDisplayType,
    EnviroDisplayType,
    OpenModal,
    PortType,
    PositionType,
    RootState,
    SwitchType,
    ToolTipType,
    TransitType,
    UserType,
} from 'types';
import { MainControlsInterface, MapControlsInterface } from 'types/functions';
import { MetOceanData } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone } from 'utils/formHandlers';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface TransitToolTipProps {
    outlineInterval: number;
    toolTip: ToolTipType;
    mainControls: MainControlsInterface;
    mapControls: MapControlsInterface;
    port: PortType;
    dateTimeFormat: DateTimeFormat;
    openModelFunction: OpenModal;
    setOutlineIntervalAction: (outlineInterval: number) => void;
    switchs: SwitchType;
    user: UserType;
}

interface TransitToolTipState {
    toolTip: ToolTipType | null;
    transit: TransitType | null;
    dataDisplay: DataDisplayType;
    position: PositionType | null;
    loading: boolean;
    times: number[];
    timeMenu: boolean;
    outlineInterval: number;
    activeTab: string;
    metOceanData: MetOceanData[];
    switchs: SwitchType;
    enviroDisplay: EnviroDisplayType;
}

class TransitToolTip extends Component<TransitToolTipProps, TransitToolTipState> {
    constructor(props: TransitToolTipProps) {
        super(props);
        this.state = {
            enviroDisplay: props.port.meta_data.enviroDisplay,
            switchs: clone(props.switchs),
            dataDisplay: props.port.meta_data.dataDisplay,
            toolTip: clone(props.toolTip),
            position: null,
            transit: null,
            loading: true,
            timeMenu: false,
            outlineInterval: 10,
            times: OUTLINE_INTERVALS,
            activeTab: 'wind',
            metOceanData: [],
        };
    }

    static getDerivedStateFromProps(props: TransitToolTipProps, state: TransitToolTipState) {
        if (checkDifferent(props.switchs, state.switchs, true)) {
            return {
                switchs: clone(props.switchs),
            };
        }
        if (props.outlineInterval !== state.outlineInterval) {
            return {
                outlineInterval: props.outlineInterval,
            };
        }

        if (checkDifferent(props.toolTip, state.toolTip)) {
            return {
                toolTip: clone(props.toolTip),
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.setState(
            {
                toolTip: this.props.toolTip,
            },
            this.loadTransitData
        );
    }

    componentDidUpdate(prevProps: TransitToolTipProps, prevState: TransitToolTipState) {
        if (
            checkDifferent(prevState.toolTip?.data, this.state.toolTip?.data) ||
            checkDifferent(prevState.toolTip?.dataIndex, this.state.toolTip?.dataIndex)
        ) {
            this.loadTransitData();
        }
    }

    loadTransitData = async () => {
        this.setState({ loading: true }, async () => {
            //@ts-ignore
            const { transit } = this.props.mainControls.getTransit(this.state.toolTip?.data.parent);

            try {
                const metOceanData = await this.props.mainControls.getMetOceanData(
                    //@ts-ignore
                    transit,
                    this.state.toolTip?.dataIndex.time
                );
                this.setState({
                    loading: false,
                    metOceanData: metOceanData,
                    //@ts-ignore
                    transit: transit,
                    position: this.props.mainControls.getBestPosition(
                        this.state.toolTip?.data.parent,
                        this.state.toolTip?.dataIndex.index,
                        {
                            //@ts-ignore
                            east_utm: this.state.toolTip?.east_utm,
                            //@ts-ignore
                            north_utm: this.state.toolTip?.north_utm,
                        },
                        this.state.toolTip?.dataIndex.type
                    ),
                });
            } catch (error) {
                this.setState({
                    loading: false,
                    metOceanData: [],
                    //@ts-ignore
                    transit: transit,
                    position: this.props.mainControls.getBestPosition(
                        this.state.toolTip?.data.parent,
                        this.state.toolTip?.dataIndex.index,
                        {
                            //@ts-ignore
                            east_utm: this.state.toolTip?.east_utm,
                            //@ts-ignore
                            north_utm: this.state.toolTip?.north_utm,
                        },
                        this.state.toolTip?.dataIndex.type
                    ),
                });
                console.log('INFO : request canceled');
            }
        });
    };

    getDisplay = (type: string, key: string) => {
        const dataDisplay = this.state?.dataDisplay;

        if (dataDisplay?.[type]?.[key]) {
            return dataDisplay[type][key];
        }

        return {};
    };

    updateTransit = () => {
        //@ts-ignore
        const { transit } = this.props.mainControls.getTransit(this.state?.toolTip?.data.parent);
        setTimeout(() => {
            this.setState({
                transit,
            });
        }, 200);
    };

    displayValue = (value) => {
        if (!this.state.position) {
            return '-';
        }

        if (this.state.position[value] === 'N/A' || (!this.state.position[value] && this.state.position[value] !== 0)) {
            return 'N/A';
        }


        return `${parseFloat(
            //@ts-ignore
            this.state.position[value] * this.getDisplay('transit', value).database2display_unit_factor
        ).toFixed(this.getDisplay('transit', value).decimal)}${this.getDisplay('transit', value).unit}`;
    };

    //unused function
    addTagsAndComments = (id: number) => {
        this.props.openModelFunction(
            'transitTagsAndCommentsModel',
            0,
            'medium',
            { tab: 'tags', id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('transitTagsAndCommentsModel');
                },
                onConfirm: () => {
                    console.log('saved');
                },
            },
            true
        );
    };

    //unused function
    editTransit = (id: number | undefined) => {
        this.props.openModelFunction(
            'editTransitModel',
            0,
            'medium',
            { id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('editTransitModel');
                },
                onConfirm: () => {
                    console.log('saved');
                },
            },
            true
        );
    };

    toggleTimeMenu = () => {
        this.setState({
            timeMenu: !this.state.timeMenu,
        });
    };

    activeTab = (activeTab: string) => {
        this.setState({
            activeTab,
        });
    };

    updateOutlineInterval = (time) => {
        this.props.setOutlineIntervalAction(time);
    };

    getValue = (items, key) => {
        const item = items.find((item) => item.key == key);
        return item ? item : { value: '-', unite: '' };
    };

    formatValue = (instrumentValues, key, type) => {
        const instrumentValue = this.getValue(instrumentValues, key);
        const display = this.state.enviroDisplay[type][key];

        let value = instrumentValue.value;
        if (value === '-' || !value) {
            return '-';
        }
        if (instrumentValue.unit !== display.unit) {
            value = value * display.database2display_unit_factor;
        }
        if (!value) {
            return 'N/A';
        }
        return `${value.toFixed(display.decimal)} ${display.unit}`;
    };

    reversAngle = (angle) => {
        const difference = angle - 180;

        if (difference < 0) return 360 + difference;

        return difference;
    };
    render() {
        return (
            <div className="flex flex-col w-auto min-w-56 relative overflow-hidden rounded-md group">
                <div className="w-full h-full absolute z-10" id={`Drag-${this.state?.toolTip?.uuid}`}></div>
                <div className="w-full flex">
                    <div className="flex flex-col w-full">
                        <div className="flex justify-between gap-x-2 items-start mx-2 mt-2">
                            <div className="capitalize font-bold ">
                                <span
                                    className={twclsx(
                                        (!hasPermission(this.props.user, this.props.port.id, ['identifyTransits']) ||
                                            !this.state.switchs.identifyTransits.value) &&
                                            'blurText'
                                    )}
                                >
                                    {this.state.toolTip?.data.name}{' '}
                                </span>
                                ({this.state.transit?.vessel.vessel_category.name})
                            </div>
                            <div
                                onClick={() => {
                                    this.props.mapControls.chart?.hideTooltipById(this.props.toolTip.uuid);
                                }}
                                className=" z-20 flex justify-center items-end justify-items-end cursor-pointer"
                            >
                                <Icon className="w-4 h-4 text-white">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M18 6l-12 12"></path>
                                    <path d="M6 6l12 12"></path>
                                </Icon>
                            </div>
                        </div>

                        {this.state.loading ? (
                            <LoaderSpinner className="my-10 mx-20" variant="button"></LoaderSpinner>
                        ) : (
                            <>
                                <div className="flex-1 w-full truncate mx-2">
                                    <div className="flex justify-between items-start">
                                        <div className="  items-center   ">
                                            <h3 className="text-activeGray text-sm leading-5 font-medium truncate">
                                                {this.state.transit?.vessel.loa_m}
                                                {this.getDisplay('vessel', 'loa_m').unit} x{' '}
                                                {this.state.transit?.vessel.beam_m}
                                                {this.getDisplay('vessel', 'beam_m').unit} (
                                                {this.state.transit?.draft_m}
                                                {this.getDisplay('vessel', 'draft_m').unit})
                                            </h3>
                                            <p className=" text-red-500  mb-1  text-sm font-bold  leading-4 truncate">
                                                <span
                                                    className={twclsx(
                                                        (!hasPermission(this.props.user, this.props.port.id, [
                                                            'identifyTransits',
                                                        ]) ||
                                                            !this.state.switchs.identifyTransits.value) &&
                                                            'blurText'
                                                    )}
                                                >
                                                    {this.props.dateTimeFormat
                                                        .parseDateTime(this.state.position?.valid_time_utc)
                                                        .formatDateTimeToString('dd LLL yyyy')}
                                                </span>
                                                <span className="ml-1">
                                                    {this.props.dateTimeFormat
                                                        .parseDateTime(this.state.position?.valid_time_utc)
                                                        .formatDateTimeToString('HH:mm:ss Z')}
                                                </span>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="h-px w-full bg-gray-300 my-1"></div>
                                </div>
                                {this.state.switchs.chartManoeuvreInformationOnChart?.value && (
                                    <div className="  text-sm border-b  border-gray-400 mx-2">
                                        <div className="w-full border-collapse items-center">
                                            <div className="flex justify-start ">
                                                <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                    <div className="w-2/3">
                                                        {this.getDisplay('transit', 'heading_deg').name} :
                                                    </div>

                                                    <div className="text-black font-bold  pl-2 text-right w-1/3">
                                                        {this.displayValue('heading_deg')}
                                                    </div>
                                                </div>

                                                <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                    <div className="w-1/2">
                                                        {this.getDisplay('transit', 'sog_mps').name} :
                                                    </div>
                                                    <div className="text-black font-bold  pl-2 text-left w-1/2">
                                                        {this.displayValue('sog_mps')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-start ">
                                                <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                    <div className="w-2/3">
                                                        {this.getDisplay('transit', 'cog_deg').name} :
                                                    </div>
                                                    <div className="text-black font-bold pl-2 text-right w-1/3">
                                                        {this.displayValue('cog_deg')}
                                                    </div>
                                                </div>
                                                <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                    <div className="w-1/2">
                                                        {this.getDisplay('transit', 'rot_deg_min').name} :
                                                    </div>
                                                    <div className="text-black font-bold pl-2 text-left w-1/2">
                                                        {this.displayValue('rot_deg_min')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex justify-start ">
                                                <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                    <div className="w-2/3">
                                                        {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                    </div>
                                                    <div className="text-black font-bold pl-2 text-right w-1/3">
                                                        {this.displayValue('drift_angle_deg')}
                                                    </div>
                                                </div>

                                                <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                    <div className="w-1/2">
                                                        {this.getDisplay('transit', 'crot_deg_min').name} :
                                                    </div>
                                                    <div className="text-black font-bold pl-2 text-left w-1/2">
                                                        {this.displayValue('crot_deg_min')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="flex justify-between items-center  ">
                                            <div>
                                                <div className="flex justify-start items-center gap-2 mr-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'heading_deg').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('heading_deg')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-start items-center gap-2 mr-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'cog_deg').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('cog_deg')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-start items-center gap-2 mr-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('drift_angle_deg')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="flex justify-start items-center gap-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'sog_mps').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('sog_mps')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-start items-center gap-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'rot_deg_min').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('rot_deg_min')}
                                                        </span>
                                                    </div>
                                                </div>
                                                <div className="flex justify-start items-center gap-2 ">
                                                    <div className="font-bold">
                                                        <span className="text-gray-600">
                                                            {this.getDisplay('transit', 'crot_deg_min').name} :
                                                        </span>
                                                        <span className="text-black">
                                                            {this.displayValue('crot_deg_min')}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                )}
                                {this.state.switchs.chartEnviromentalDataOnChart?.value && (
                                    <div className="py-1 border-b text-sm    border-gray-400 mx-2 ">
                                        <div className=" flex grow-0 flex-content text-center border-b border-gray-400 pb-1">
                                            {this.state.metOceanData.filter((x) => {
                                                return x.key == 'wind' && x.instruments.length >= 1;
                                            }).length && this.state.switchs.windData.value ? (
                                                <div
                                                    className={twclsx(
                                                        'border-r',
                                                        'border-gray-400',
                                                        'px-2',
                                                        'grow',
                                                        'cursor-pointer',
                                                        'z-20',
                                                        this.state.activeTab === 'wind'
                                                            ? 'text-primary-link'
                                                            : 'text-black'
                                                    )}
                                                    onClick={() => {
                                                        this.activeTab('wind');
                                                    }}
                                                >
                                                    {translate('Wind')}
                                                </div>
                                            ) : null}
                                            {this.state.metOceanData.filter((x) => {
                                                return x.key == 'watercurrent' && x.instruments.length >= 1;
                                            }).length && this.state.switchs.watercurrentData.value ? (
                                                <div
                                                    className={twclsx(
                                                        'border-r',
                                                        'border-gray-400',
                                                        'px-2',
                                                        'grow',
                                                        'cursor-pointer',
                                                        'z-20',
                                                        this.state.activeTab === 'watercurrent'
                                                            ? 'text-primary-link'
                                                            : 'text-black'
                                                    )}
                                                    onClick={() => {
                                                        this.activeTab('watercurrent');
                                                    }}
                                                >
                                                    {translate('Water current')}
                                                </div>
                                            ) : null}
                                            {this.state.metOceanData.filter((x) => {
                                                return x.key == 'tide' && x.instruments.length >= 1;
                                            }).length && this.state.switchs.tideData.value ? (
                                                <div
                                                    className={twclsx(
                                                        'border-r',
                                                        'border-gray-400',
                                                        'px-2',
                                                        'grow',
                                                        'cursor-pointer',
                                                        'z-20',
                                                        this.state.activeTab === 'tide'
                                                            ? 'text-primary-link'
                                                            : 'text-black'
                                                    )}
                                                    onClick={() => {
                                                        this.activeTab('tide');
                                                    }}
                                                >
                                                    {translate('tide')}
                                                </div>
                                            ) : null}
                                            {this.state.metOceanData.filter((x) => {
                                                return x.key == 'wave' && x.instruments.length >= 1;
                                            }).length && this.state.switchs.waveData.value ? (
                                                <div
                                                    className={twclsx(
                                                        'px-2',
                                                        'grow',
                                                        'cursor-pointer',
                                                        'z-20',
                                                        this.state.activeTab === 'wave'
                                                            ? 'text-primary-link'
                                                            : 'text-black'
                                                    )}
                                                    onClick={() => {
                                                        this.activeTab('wave');
                                                    }}
                                                >
                                                    {translate('Wave')}
                                                </div>
                                            ) : null}
                                        </div>
                                        {/* wind */}
                                        {this.state.activeTab === 'wind' && (
                                            <div className="flex flex-col    px-1">
                                                {this.state.metOceanData
                                                    .filter((x) => x.key == 'wind')
                                                    .map((instrumentType, instrumentIndex) => {
                                                        return (
                                                            <div key={instrumentIndex}>
                                                                <div>
                                                                    {instrumentType.instruments.map(
                                                                        (instrument, instrumentIndex) => {
                                                                            return (
                                                                                <div
                                                                                    key={instrumentIndex}
                                                                                    className=" text-sm gap-1 items-center"
                                                                                >
                                                                                    <table className="w-full">
                                                                                        <tr>
                                                                                            <td
                                                                                                className="w-40"
                                                                                                rowSpan={2}
                                                                                            >
                                                                                                <p className="w-32 truncate">
                                                                                                    {
                                                                                                        instrument.description
                                                                                                    }
                                                                                                </p>
                                                                                            </td>
                                                                                            <td className="flex gap-1 items-center justify-end pr-2">
                                                                                                <div className="z-20 leading-4 relative flex items-center justify-end">
                                                                                                    {this.getValue(
                                                                                                        instrument.values,
                                                                                                        'direction_from_deg'
                                                                                                    ).value != '-' && (
                                                                                                        <DirectionArraw
                                                                                                            name={translate(
                                                                                                                'direction_from_deg'
                                                                                                            )}
                                                                                                            degree={this.reversAngle(
                                                                                                                this.getValue(
                                                                                                                    instrument.values,
                                                                                                                    'direction_from_deg'
                                                                                                                ).value
                                                                                                            )}
                                                                                                        ></DirectionArraw>
                                                                                                    )}
                                                                                                </div>

                                                                                                <div>
                                                                                                    {this.formatValue(
                                                                                                        instrument.values,
                                                                                                        'speed_kn',
                                                                                                        instrumentType.key
                                                                                                    )}
                                                                                                </div>
                                                                                                <div>
                                                                                                    {translate('gust')}{' '}
                                                                                                    {this.formatValue(
                                                                                                        instrument.values,
                                                                                                        'gust_kn',
                                                                                                        instrumentType.key
                                                                                                    )}
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}

                                        {/* watercurrent */}
                                        {this.state.activeTab === 'watercurrent' && (
                                            <div className="flex flex-col    px-1">
                                                {this.state.metOceanData
                                                    .filter((x) => x.key == 'watercurrent')
                                                    .map((instrumentType, instrumentIndex) => {
                                                        return (
                                                            <div key={instrumentIndex}>
                                                                <div>
                                                                    {instrumentType.instruments.map(
                                                                        (instrument, instrumentIndex) => {
                                                                            return (
                                                                                <div
                                                                                    key={instrumentIndex}
                                                                                    className=" text-sm gap-1 items-center"
                                                                                >
                                                                                    <table className="w-full">
                                                                                        <tr>
                                                                                            <td
                                                                                                className="w-40"
                                                                                                rowSpan={2}
                                                                                            >
                                                                                                <p className="w-32 truncate">
                                                                                                    {
                                                                                                        instrument.description
                                                                                                    }
                                                                                                </p>
                                                                                            </td>
                                                                                            <td className="flex items-center justify-end pr-2">
                                                                                                <div className=" z-20 leading-4 relative flex items-center">
                                                                                                    {this.getValue(
                                                                                                        instrument.values,
                                                                                                        'direction_from_deg'
                                                                                                    ).value !== '-' && (
                                                                                                        <DirectionArraw
                                                                                                            name={translate(
                                                                                                                'direction_from_deg'
                                                                                                            )}
                                                                                                            degree={this.reversAngle(
                                                                                                                this.getValue(
                                                                                                                    instrument.values,
                                                                                                                    'direction_from_deg'
                                                                                                                ).value
                                                                                                            )}
                                                                                                        ></DirectionArraw>
                                                                                                    )}

                                                                                                    <div>
                                                                                                        {this.formatValue(
                                                                                                            instrument.values,
                                                                                                            'speed_kn',
                                                                                                            instrumentType.key
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                        {/* tide */}
                                        {this.state.activeTab === 'tide' && (
                                            <div className="flex flex-col    px-1">
                                                {this.state.metOceanData
                                                    .filter((x) => x.key == 'tide')
                                                    .map((instrumentType, instrumentIndex) => {
                                                        return (
                                                            <div key={instrumentIndex}>
                                                                <div>
                                                                    {instrumentType.instruments.map(
                                                                        (instrument, instrumentIndex) => {
                                                                            return (
                                                                                <div
                                                                                    key={instrumentIndex}
                                                                                    className=" text-sm gap-1 items-center"
                                                                                >
                                                                                    <table className="w-full">
                                                                                        <tr>
                                                                                            <td
                                                                                                className="w-40"
                                                                                                rowSpan={2}
                                                                                            >
                                                                                                <p className="w-32 truncate">
                                                                                                    {
                                                                                                        instrument.description
                                                                                                    }
                                                                                                </p>
                                                                                            </td>
                                                                                            <td className=" relative flex items-center "></td>
                                                                                            <td
                                                                                                rowSpan={2}
                                                                                                className="flex items-center justify-end pr-2"
                                                                                            >
                                                                                                <div className="flex items-center relative">
                                                                                                    <Icon className="w-3 h-3 mr-1">
                                                                                                        <path
                                                                                                            stroke="none"
                                                                                                            d="M0 0h24v24H0z"
                                                                                                            fill="none"
                                                                                                        ></path>
                                                                                                        <polyline points="3 8 6 5 9 8"></polyline>
                                                                                                        <polyline points="3 16 6 19 9 16"></polyline>
                                                                                                        <line
                                                                                                            x1="6"
                                                                                                            y1="5"
                                                                                                            x2="6"
                                                                                                            y2="19"
                                                                                                        ></line>
                                                                                                        <line
                                                                                                            x1="13"
                                                                                                            y1="6"
                                                                                                            x2="20"
                                                                                                            y2="6"
                                                                                                        ></line>
                                                                                                        <line
                                                                                                            x1="13"
                                                                                                            y1="12"
                                                                                                            x2="20"
                                                                                                            y2="12"
                                                                                                        ></line>
                                                                                                        <line
                                                                                                            x1="13"
                                                                                                            y1="18"
                                                                                                            x2="20"
                                                                                                            y2="18"
                                                                                                        ></line>
                                                                                                    </Icon>
                                                                                                    <div>
                                                                                                        {this.formatValue(
                                                                                                            instrument.values,
                                                                                                            'height_m',
                                                                                                            instrumentType.key
                                                                                                        )}
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                            <td> </td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td className="flex items-center "></td>

                                                                                            <td> </td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                        {/* wave */}
                                        {this.state.activeTab === 'wave' && (
                                            <div className="flex flex-col    px-1">
                                                {this.state.metOceanData
                                                    .filter((x) => x.key == 'wave')
                                                    .map((instrumentType, instrumentIndex) => {
                                                        return (
                                                            <div key={instrumentIndex}>
                                                                <div>
                                                                    {instrumentType.instruments.map(
                                                                        (instrument, instrumentIndex) => {
                                                                            return (
                                                                                <div
                                                                                    key={instrumentIndex}
                                                                                    className=" text-sm gap-1 items-center"
                                                                                >
                                                                                    <table className="w-full">
                                                                                        <tr>
                                                                                            <td
                                                                                                className="w-40"
                                                                                                rowSpan={4}
                                                                                            >
                                                                                                <div className="flex w-32">
                                                                                                    <div
                                                                                                        className="truncate"
                                                                                                        title={
                                                                                                            instrument.description
                                                                                                        }
                                                                                                    >
                                                                                                        {
                                                                                                            instrument.description
                                                                                                        }
                                                                                                    </div>
                                                                                                    {this.getValue(
                                                                                                        instrument.values,
                                                                                                        'mean_direction_from_deg'
                                                                                                    ).value != '-' && (
                                                                                                        <div className="z-20  leading-4 relative flex items-center">
                                                                                                            {this.getValue(
                                                                                                                instrument.values,
                                                                                                                'mean_direction_from_deg'
                                                                                                            ).value !==
                                                                                                                null && (
                                                                                                                <DirectionArraw
                                                                                                                    name={translate(
                                                                                                                        'mean_direction_from_deg'
                                                                                                                    )}
                                                                                                                    degree={
                                                                                                                        this.getValue(
                                                                                                                            instrument.values,
                                                                                                                            'mean_direction_from_deg'
                                                                                                                        )
                                                                                                                            .value
                                                                                                                    }
                                                                                                                ></DirectionArraw>
                                                                                                            )}
                                                                                                        </div>
                                                                                                    )}
                                                                                                </div>
                                                                                            </td>
                                                                                            <td></td>
                                                                                            <td></td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td>
                                                                                                <div className="grid grid-rows-3">
                                                                                                    <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                        <td className="text-sm col-span-1">
                                                                                                            sea
                                                                                                        </td>
                                                                                                        <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'significant_wave_height_sea_m',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'peak_wave_period_sea_s',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </td>
                                                                                                    </div>
                                                                                                    <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                        <td className="text-sm  col-span-1">
                                                                                                            swell
                                                                                                        </td>
                                                                                                        <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'significant_wave_height_swell_m',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'peak_wave_period_swell_s',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </td>
                                                                                                    </div>
                                                                                                    <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                        <td className="text-sm col-span-1">
                                                                                                            total
                                                                                                        </td>
                                                                                                        <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'significant_wave_height_total_m',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                            <div>
                                                                                                                {this.formatValue(
                                                                                                                    instrument.values,
                                                                                                                    'peak_wave_period_total_s',
                                                                                                                    instrumentType.key
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </td>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </table>
                                                                                </div>
                                                                            );
                                                                        }
                                                                    )}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                    </div>
                                )}

                                {this.state.timeMenu && (
                                    <div className="z-20 py-1 border-b text-sm border-gray-400 mx-2">
                                        <div className="flex items-center gap-3">
                                            <div className="flex items-center">
                                                <div
                                                    onClick={async () => {
                                                        this.updateOutlineInterval(0);
                                                        this.updateTransit();
                                                    }}
                                                    data-tooltip-id="tooltipVesselOutline"
                                                    className={`font-bold cursor-pointer p-1 ${
                                                        (!this.state.transit?.options.outline ||
                                                            this.state.outlineInterval === 0) &&
                                                        'bg-gray-300 rounded-md'
                                                    }`}
                                                >
                                                    <Tooltip
                                                        id="tooltipVesselOutline"
                                                        html={translate('Hide vessel outline')}
                                                        place="top"
                                                        positionStrategy="fixed"
                                                        className="z-60"
                                                    />
                                                    <div>{translate('off')}</div>
                                                </div>
                                                {this.state.times.map((time, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            onClick={async () => {
                                                                this.updateOutlineInterval(time);
                                                                this.updateTransit();
                                                            }}
                                                            className={`font-bold cursor-pointer p-1 ${
                                                                this.state.outlineInterval === time &&
                                                                this.state.transit?.options.outline &&
                                                                'bg-gray-300 rounded-md'
                                                            }`}
                                                        >
                                                            {time < 60
                                                                ? `${time}${translate('sec')} `
                                                                : `${time / 60}${translate('min')}`}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}
                                <div className="z-20 text-left bg-primary-system   px-2 h-0 truncate group-hover:h-8 transition-all ease-in-out duration-300">
                                    <div className="  flex justify-between items-center  ">
                                        <div
                                            onClick={async () => {
                                                await this.props.mainControls.updatehighlight(
                                                    this.state.transit?.id || 0,
                                                    !this.state.transit?.options.highlight,
                                                    false
                                                );
                                                this.updateTransit();
                                            }}
                                            data-tooltip-id="tooltipHighlight"
                                            className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipHighlight"
                                                html={`${translate('Highlight transit')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path
                                                    fill={this.state.transit?.options.highlight ? '#FFC000' : '#fffff'}
                                                    d="M12 17.75l-6.172 3.245l1.179 -6.873l-5 -4.867l6.9 -1l3.086 -6.253l3.086 6.253l6.9 1l-5 4.867l1.179 6.873z"
                                                />
                                            </Icon>
                                        </div>

                                        <div
                                            onClick={() => {
                                                //@ts-ignore
                                                this.addTagsAndComments(this.state.transit?.id);
                                            }}
                                            data-tooltip-id="tooltipTagsAndComments"
                                            className="    cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipTagsAndComments"
                                                html={`${translate('Tags and comments')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
                                            </Icon>
                                        </div>
                                        {this.props.mainControls.getDisplayedTransits().length > 1 ? (
                                            <div
                                                data-tooltip-id="tooltipThisTransit"
                                                className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                                onClick={async () => {
                                                    await this.props.mainControls.updateDisplayAll(
                                                        [this.state.transit?.id || 0],
                                                        true,
                                                        false
                                                    );
                                                    this.updateTransit();
                                                }}
                                            >
                                                <Tooltip
                                                    id="tooltipThisTransit"
                                                    html={`${translate('Show only this transit')}`}
                                                    place="top"
                                                    positionStrategy="fixed"
                                                    className="z-60"
                                                />
                                                <Icon className="w-4 h-4 text-white">
                                                    <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                                    <path d="M11.102 17.957c-3.204 -.307 -5.904 -2.294 -8.102 -5.957c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a19.5 19.5 0 0 1 -.663 1.032"></path>

                                                    <path d="M18 21v-7l-2 2" />
                                                </Icon>
                                            </div>
                                        ) : (
                                            <div
                                                data-tooltip-id="tooltipThisTransit"
                                                className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                                onClick={async () => {
                                                    await this.props.mainControls.updateDisplayAll([0], false, false);
                                                    this.updateTransit();
                                                }}
                                            >
                                                <Tooltip
                                                    id="tooltipThisTransit"
                                                    html={`${translate('Show all transits')}`}
                                                    place="top"
                                                    positionStrategy="fixed"
                                                    className="z-60"
                                                />
                                                <Icon className="w-4 h-4 text-white">
                                                    <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                                    <path d="M11.102 17.957c-3.204 -.307 -5.904 -2.294 -8.102 -5.957c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6a19.5 19.5 0 0 1 -.663 1.032"></path>
                                                    <path d="M15 19l2 2l4 -4"></path>
                                                </Icon>
                                            </div>
                                        )}

                                        <div
                                            onClick={async () => {
                                                await this.props.mainControls.updateDisplay(
                                                    this.state.transit?.id || 0,
                                                    !this.state.transit?.options.display,
                                                    false
                                                );
                                                this.updateTransit();
                                            }}
                                            data-tooltip-id="tooltipHideOrShowThisTransit"
                                            className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipHideOrShowThisTransit"
                                                html={`${
                                                    this.state.transit?.options.display
                                                        ? translate('Hide this transit')
                                                        : translate('Show this transit')
                                                }`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                                                {this.state.transit?.options.display ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div>

                                        <div
                                            onClick={async () => {
                                                await this.props.mainControls.updateDrawSweptPath(
                                                    this.state.transit?.id || 0,
                                                    !this.state.transit?.options.drawSweptPath
                                                );
                                                this.updateTransit();
                                            }}
                                            data-tooltip-id="tooltipToggleSwrptPath"
                                            className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipToggleSwrptPath"
                                                html={`${
                                                    this.state.transit?.options.drawSweptPath
                                                        ? translate('Hide swept path')
                                                        : translate('Show swept path')
                                                }`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M4 19l4 -14"></path>
                                                <path d="M16 5l4 14"></path>
                                                <path d="M12 8v-2"></path>
                                                <path d="M12 13v-2"></path>
                                                <path d="M12 18v-2"></path>
                                                {this.state.transit?.options.drawSweptPath ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div>

                                        <div
                                            onClick={async () => {
                                                await this.props.mainControls.updateDrawTrack(
                                                    this.state.transit?.id || 0,
                                                    !this.state.transit?.options.drawTrack
                                                );
                                                this.updateTransit();
                                            }}
                                            data-tooltip-id="tooltipToggleTrack"
                                            className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipToggleTrack"
                                                html={`${
                                                    this.state.transit?.options.drawTrack
                                                        ? translate('Hide track')
                                                        : translate('Show track')
                                                }`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M4 16l6 -7l5 5l5 -6"></path>
                                                <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                {this.state.transit?.options.drawTrack ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div>
                                        {/* <div
                                            onClick={async () => {
                                                await this.props.mainControls.updateDrawVesselOutline(
                                                    this.state.transit?.id || 0,
                                                    !this.state.transit?.options.outline
                                                );

                                                this.updateTransit();
                                            }}
                                            data-tooltip-id="tooltipVesselOutline"
                                            className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipVesselOutline"
                                                html={`${
                                                    this.state.transit?.options.outline
                                                        ? translate('Hide vessel outline')
                                                        : translate('Show vessel outline')
                                                }`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M3 6m0 6a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6z" />
                                                {this.state.transit?.options.outline ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div> */}

                                        <div
                                            onClick={() => {
                                                this.editTransit(this.state.transit?.id);
                                            }}
                                            data-tooltip-id="tooltipEditTransit"
                                            className="relative  hidden cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipEditTransit"
                                                html={`${translate('Edit transit')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4"></path>
                                                <path d="M13.5 6.5l4 4"></path>
                                            </Icon>
                                        </div>
                                        <div
                                            onClick={this.toggleTimeMenu}
                                            data-tooltip-id="tooltipTime"
                                            className="relative    cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipTime"
                                                html={`${translate('Outline interval')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                                <path d="M12 12l-3 -2" />
                                                <path d="M12 7v5" />
                                            </Icon>
                                        </div>

                                        <div
                                            onClick={() => {
                                                this.props.mainControls.playbackTransit(
                                                    this.state.transit?.id,
                                                    this.props.dateTimeFormat.parseDateTime(
                                                        this.state.position?.valid_time_utc
                                                    )
                                                );
                                            }}
                                            data-tooltip-id="tooltipReplayThisTransit"
                                            className="relative   cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        >
                                            <Tooltip
                                                id="tooltipReplayThisTransit"
                                                html={`${translate('Replay this transit')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-white">
                                                <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"></path>
                                                <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"></path>
                                            </Icon>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const transitToolTipStateToProps = (state: RootState) => ({
    outlineInterval: state.map.outlineInterval,
    port: state.port.port,
    switchs: state.layout.switchs,
    dateTimeFormat: state.port.dateTimeFormat,
    mainControls: state.layout.mainControls,
    mapControls: state.map.mapControls,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const transitToolTipDispatchToProps = (dispatch: any) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
});

export default connect(transitToolTipStateToProps, transitToolTipDispatchToProps)(TransitToolTip);
